/* Pure helpers with no home of their own.

   clamp lives here rather than in state/store.js because core/ modules need it
   and core/ must not depend on app state — text-outline.js reaches for it inside
   creaseNormals. store.js re-exports it, so every existing call site is
   unchanged. */

export const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
